import React, { useEffect, createElement } from 'react';
export function SEO() {
  useEffect(() => {
    // Seitentitel setzen
    document.title = 'Josephine Henkel | Energieberatung & Architektur Berlin';
    // Hilfsfunktion zum Setzen oder Aktualisieren von Meta-Tags
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // SEO Meta-Tags
    setMetaTag('description', 'Josephine Henkel: Ihre Architektin und Energieeffizienz-Expertin für Bestandsgebäude in Berlin. Individueller Sanierungsfahrplan (iSFP), BAFA/KfW Fördermittelberatung und nachhaltige Modernisierung.');
    setMetaTag('keywords', 'Energieberaterin Berlin, Energieberatung Berlin, Energieberater Bestandsgebäude, Individueller Sanierungsfahrplan, iSFP Berlin, Energieberatung Wohngebäude, BAFA Energieberatung, Fördermittel Sanierung, Energieeffizienz Wohngebäude, Architektur');
    setMetaTag('author', 'Josephine Henkel');
    // OpenGraph Meta-Tags (für Social Media & Link-Vorschauen)
    setMetaTag('og:title', 'Josephine Henkel | Energieberatung & Architektur Berlin', true);
    setMetaTag('og:description', 'Architektur trifft Energieberatung. Nachhaltige und individuelle Sanierungskonzepte für Bestandsgebäude in Berlin und Umgebung.', true);
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', 'https://henkelenergie.de', true);
    setMetaTag('og:locale', 'de_DE', true);
    setMetaTag('og:site_name', 'Josephine Henkel Energieberatung', true);
    // Sprache des HTML-Dokuments für Suchmaschinen auf Deutsch setzen
    document.documentElement.lang = 'de';
  }, []);
  return null;
}